<template>
	<div class="containerPage">

		<div class="top-btns">
			<el-button size="small" :type="isPlainDefault" @click="newAdd(null)">{{$t('writing.chater')}}</el-button>
			<el-button size="small" :type="isPlain[0]" class="info-updata-btn" @click="toggleList('草稿箱',1)">
				{{$t('writing.draft')}}
			</el-button>
			<el-tooltip class="item" effect="light" :disabled="!handleGuess()"
				content="You need to complete the contract before publishing the chapter." placement="top-start">
				<el-button size="small" :type="isPlain[1]" class="info-updata-btn" @click="toggleList('已发布',2)"
					:disabled="handleGuess()">
					{{$t('writing.issue')}}
				</el-button>
			</el-tooltip>
			<el-button size="small" :type="isPlain[2]" class="info-updata-btn" @click="toggleList('回收站',3)">
				{{$t('writing.recycle')}}
			</el-button>
			<el-button size="small" class="info-updata-btn" @click="toggleBack">{{$t('writing.return')}}</el-button>
			<el-upload v-show="false" style="margin-left: 10px;" action="" :limit="1">
				<el-button size="small" type="primary">{{$t('writing.carrier')}}</el-button>
			</el-upload>
			<el-upload v-show="false" style="margin-left: 10px;" action="" :limit="1">
				<el-button size="small" type="primary">{{$t('writing.batch')}}</el-button>
			</el-upload>
		</div>

		<div class="default-content" v-if="edit||add">
			<div class="top-content" v-show="false">
				<div class="title">
					<span class="name">{{$t('writing.subsection')}}</span>
				</div>
				<div class="center">
					<el-form ref="form" :model="info" label-width="90px" label-position="left" size="small">
						<el-form-item :label="$t('writing.classification')" class="info-form-row">
							<el-input v-model="info.avatar" :placeholder="$t('writing.classification1')"
								style="width: 300px;" class="info-form-item"></el-input>
						</el-form-item>
						<el-form-item :label="$t('writing.classificationInfo')" class="info-form-row">
							<el-input type="textarea" :rows="4" v-model="info.address"
								:placeholder="$t('writing.inputClassification')">
							</el-input>
						</el-form-item>
						<el-form-item class="them-btn">
							<el-button type="warning" class="zhu-btn info-updata-btn" size="medium">
								{{$t('writing.save')}}
							</el-button>
							<el-button class="info-updata-btn" size="medium">{{$t('writing.cancel')}}</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="footer-content">

				<div class="title">
					<span class="name">{{editStatus ? $t('writing.chater') : "Edit Chapter"}}</span>
				</div>
				<div class="center">
					<div class="row">
						<!-- <span>添加新章节</span> -->
						<!-- <span>第1章</span> -->
						<span v-show="false">{{$t('writing.title')}}
							<el-input :placeholder="$t('writing.No1')" style="width: 180px;" size="medium"
								class="info-form-item" />
						</span>
						<span v-show="false">{{$t('writing.content')}}
							<el-input style="width: 350px;" size="medium" class="info-form-item" />
						</span>
					</div>
					<el-form v-loading="loading" ref="form" :model="reqAddChapter.data[0]" :rules="rules"
						label-width="90px" label-position="left" size="small">
						<el-form-item v-show="editStatus" :label="$t('writing.preChapter')" prop="publishChapter">
							<el-input :disabled="true" size="medium" class="info-form-item" v-model="publishChapter" />
						</el-form-item>
						<el-form-item v-show="editStatus" :label="editStatus ? $t('writing.title') :'Title' "
							:error="autoInputErr" label-width="130px" prop="chapterNo" class="is-required">
							<el-input v-show="editStatus" size="medium" class="info-form-item" style="width:10%"
								v-model="autoInput" @input="checkInput" />
							<el-alert type="warning"
								description="The chapter number will appear in the app's chapter title.">
							</el-alert>
						</el-form-item>
						<el-form-item label="Title" :error="nameInputErr">
							<el-input :placeholder="$t('writing.title1')" size="medium" class="info-form-item"
								style="width:80%" v-model="reqAddChapter.data[0].name" />
							<el-alert type="warning"
								description='If no title is entered, it will default to displaving only "Chapter + number"'>
							</el-alert>
						</el-form-item>
						<el-form-item :label="$t('writing.content')" class="info-form-row" prop="content">
							<Tinymce id="translateTinymce" class="fwb-tinymce" @contentHandle="contentChange"
								v-model="reqAddChapter.data[0].content" :placeholder="'ee'"
								:toolbar="'undo | bold italic'" />

							<el-alert type="warning"
								description="Please enter your chapter content here. Special characters and emoji expressions are not allowed here.">
							</el-alert>
						</el-form-item>
						<el-form-item :label="$t('writing.authorWords')" class="info-form-row" prop="authorWords">
							<el-input type="textarea" :rows="3" v-model="reqAddChapter.data[0].authorWords"
								:placeholder="$t('writing.writeauthorWords')" />
						</el-form-item>
						<el-form-item class="them-btn">
							<el-button class="info-updata-btn" size="medium" @click="btnClick(4)" :disabled="isSubmit"
								v-show="chapterIsEdit">
								{{$t('writing.saveDraft')}}
							</el-button>
							<el-button class="info-updata-btn" size="medium" @click="btnClick(3)">
								{{$t('writing.preview')}}
							</el-button>
							<el-button type="warning" class="zhu-btn info-updata-btn" size="medium" @click="btnClick(1)"
								v-show="chapterIsEdit" :disabled="isSubmit">
								{{$t('writing.nowsent')}}
							</el-button>
							<el-button class="info-updata-btn" size="medium" @click="btnClick(2)"
								v-show="chapterIsEdit">
								{{$t('writing.sent')}}
							</el-button>
							<el-button class="info-updata-btn" size="medium" @click="btnClick(5)"
								v-show="chapterIsEdit">
								{{$t('writing.cancel')}}
							</el-button>
							<span class="info-updata-words">{{$t('writing.num')}} {{words}}</span>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<div class="typeList-content" v-else>
			<contentList :loading="loading" ref="contentList" :title="contentTitle" :tableData="tableData"
				:total="total" :pageNum="reqDataList.data.page" :pageSize="reqDataList.data.limit"
				@refreshList="refreshList" @rowClick="rowClick" @handleCurrentChange="handleCurrentChange"
				@publishClick="publishClick" @searchChapter="searchChapter" :bookInfo="bookInfo"
				:hasPublished="hasPublished" @handleSelectionChange="handleSelectionChange" @fromParent />
		</div>
		<el-dialog :title="$t('writing.task')" :visible.sync="dialogFormVisible">
			<el-form :model="scdModel" :rules="scdRules" ref="scdForm">
				<div>
					<el-form-item :label="$t('writing.time')" prop="time">
						<el-date-picker v-model="scdModel.time" type="datetime" :placeholder="$t('writing.date')">
						</el-date-picker>
						<!-- <el-divider direction="vertical"></el-divider> -->
						<!-- <span style="padding: 0 0 0 20px;color:red">Pulish base on the time zone of UTC+0 </span>
 -->
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeSechedule">{{$t('writing.cancel')}}</el-button>
				<el-button type="primary" @click="comfrimSchedule('scdForm')">{{$t('writing.sure')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog title="预览" :visible.sync="viewShowDialog" width="440px" :close-on-click-modal="false"
			:show-close="false">
			<div class="viewModul">
				<div class="phone-content">
					<div class="html">
						<pre class="content" v-html="viewChapter.content"></pre>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="viewShowDialog = false">{{$t('writing.close')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible" :title="dialogType==='new'?'Add new chapters':'Edit chapters'"
			@close="closedialog">
			<el-form ref="chapter" :model="chapter" label-width="80px" :rules="rules">
				<!-- 		    <el-form-item label="内码" v-if="false">
		      <el-input v-model="chapter.id"></el-input>
		    </el-form-item>
		    <el-form-item label="书籍内码" v-if="false">
		      <el-input v-model="chapter.bookId"></el-input>
		    </el-form-item>
		    <el-form-item label="第几章" prop="chapterId" v-if="false">
		      <el-input v-model="chapter.chapterId"></el-input>
		    </el-form-item>
		    <el-form-item label="章节名称" prop="currentChapter" v-if="false">
		      <el-input v-model="chapter.currentChapter"></el-input>
		    </el-form-item> -->
				<el-form-item label="Chapter(RAR)" label-width="120px" style='width: 100%;display: inline-block;'
					prop="chapterParth">
					<el-upload class="upload-demo" drag :headers="request_header" :action="uploadUrl"
						:on-success="bookUpSuccess" :on-remove="handleRemove" multiple multiple :file-list="fileList">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">Drag the chapter file here, or <em>click here to upload</em></div>
						<div class="el-upload__tip" slot="tip">{{chapter.chapterParth}}</div>
					</el-upload>
				</el-form-item>
				<div style="color: red;"> One chapter corresponds to one TXT file, the chapter title should be chapter
					1,2,3..., and then package all txt files into a RAR
				</div>
				<el-button style="margin-top: 20px;" type="primary" @click="submitForm">Submit</el-button>
				<!-- 		    <el-form-item label="是否收费">{{chapter.isCharge}}
		      <el-switch v-model="chapter.isCharge" ></el-switch>
		    </el-form-item>
		    <el-form-item label="价格" :prop="chapter.isCharge? 'price':''">
		      <el-input v-model="chapter.price" type="number" :disabled="!chapter.isCharge"></el-input>
		    </el-form-item> -->
				<!-- 		    <el-form-item label="是否审核" v-if="false">
		      <el-switch v-model="chapter.reviewState" active-value="1" inactive-value="0"></el-switch>
		    </el-form-item> -->
				<el-form-item>
					<!-- <el-button type="primary" @click="confirmChapter">确认</el-button> -->
					<!-- <el-button type="danger" @click="cancelChapter">取消</el-button> -->
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
// import moment from 'moment';
import 'moment-timezone'
import {
  getAuthorChapterContentList,
  addAuthorChapterContent,
  updateAuthorChapterContentInfo,
  updateAuthorChapterContentList,
  updateSomeDataContentList,
  addPublishChapterReport,
  publish,
  getAuthorWorksInfo,
  updateAuthorChapterListStatus,
  postArticle,
  updateAuthorChapterListSechdule,
  getAuthorWorksTypeByWorkIdnew,
  getLastPublishChapter
} from '../../common/api/writing.js'
import {
  getToken
} from '@/utils/auth'
import contentList from '../../components/content-list.vue'
import {
  formatDateYYMMDDTHHmmss
} from '../../common/utils/format.js'
import Tinymce from '@/components/Tinymce'
import {

  apiGetLabelContactBook
} from '@/common/api/bookTag.js'

const defaultData = {
  data: {}
}
export default {
  components: {
    contentList,
    Tinymce
  },
  data () {
    var checkChapter = (rule, value, callback) => {
      if (this.autoInput === '') {
        callback(new Error('Chapter Number cannot be empty'))
      } else {
        callback()
      }
    }
    return {
      autoInput: 1,
      editStatus: true, // 编辑状态
      userInfo: this.$store.state.userInfo,
      request_header: {
        Authorization: 'Bearer ' + getToken()
      },
      worksTypeList: [], // 作品类型 和标签？
      success: 'success',
      isPlain: [], // 控制按钮组是否为朴素按钮
      isPlainDefault: 'success', // 默认为非朴素按钮
      chapterIsEdit: true, // 是否能编辑，发布了的不能编辑
      requestData: Object.assign({}, defaultData), // 请求的信息
      requestDatas: [], // 请求信息集合
      chapters: [], // 章节集合信息
      chapter: {}, // 章节信息
      dialogVisible: false, // 显示新增、编辑章节
      dialogType: 'new', // 显示类型
      maxChapterId: 0, // 最大章节
      uploadUrl: '', // 上传路径
      chapterList: [], // 上传返回的章节路径列表
      fileList: [], // 上传文件缓存
      uploadUrl: '', // 上传路径
      info: {},
      book: {},
      edit: false,
      add: false,
      loading: false,
      contentTitle: '草稿箱',
      tableData: [],
      total: 0,
      words: 0,
      reqDataList: {
        data: {
          status: 1,
          bookId: 0,
          page: 1,
          limit: 10
          // name:''
        }
      },
      rules: {
        chapterNo: [{
          validator: checkChapter,
          trigger: 'blur'
        }]
        /* content: [{
						required: true,
						message: 'Fill in chapter content',
						trigger: 'blur'
					}], */
      },
      reqAddChapter: {
        data: []
      },
      reqAddOneChapter: {
        data: {
          id: 0,
          name: '',
          content: '',
          authorWords: ''
        }
      },
      addChapterInfo: {
        number: '',
        name: '',
        content: '',
        summary: '',
        status: 1, // 1、草稿；2、回收；3、已发布
        bookId: 0,
        bookName: '',
        userId: 0,
        userName: '',
        // scheduledTime: "2022-05-11T09:21:00.878Z",
        isScheduled: 0,
        words: 0,
        chapterId: 0
      },
      multipleSelection: [],
      reqPublishData: { // 请求发布文章
        data: {
          Chapters: [], // 章节集合
          Books: [], // 书籍集合
          LabelShips: []
        }
      },
      reqSecdulePublishData: { // 请求定时发布文章
        data: {
          Chapters: [], // 章节集合
          Books: [], // 书籍集合
          LabelShips: []
        },
        runtime: '', // 执行时间
        timeZoneId: '' // 执行时区
      },
      bookId: 0, // 书Id
      bookInfo: {},
      dialogFormVisible: false,
      newChapterSechdule: false, // 是否新增章节定时发布，true是
      scdModel: {
        time: ''
      },
      scdRules: {
        time: [{
          required: true,
          message: 'Select',
          trigger: 'blur'
        }]
      },
      viewShowDialog: false,
      viewChapter: {},
      publishChapter: '',
      autoInputErr: '',
      nameInputErr: '',
      hasPublished: 'false',
      isSubmit: false // 是否提交中，防重
    }
  },
  methods: {
    handleGuess () {
      console.log('此时的值', this.hasPublished)
      if (this.hasPublished === 'true') {
        return false
      } else {
        if (this.bookInfo.signStatus === 1) {
          return false
        }
      }
      return true
    },
    checkInput (e) {
      // replace(/^0|[^\d]+/g,'')
      console.log('e', e)
      this.autoInput = e.replace(/^0|[^\d]+/g, '')
    },
    // 按钮组 用来区分当前选了哪个按钮
    btnGroup (index) {
      this.isPlainDefault = 'primary' // 每次点击按钮调用方法的时候给默认按钮重新赋予默认值
      this.isPlain = [' ', ' ', ' ', ' '] // 设置按钮组默认为true（默认为朴素按钮）（有几个按钮写几个）
      if (index != null) { // 如果传入的值不是null 那么代表是其他按钮触发的
        this.isPlain[index - 1] = this.isPlainDefault // 将点击的按钮设置为非朴素按钮（plain的值为false）
        // this.isPlainDefault = !this.isPlainDefault // 将默认的按钮赋值为true（变成朴素按钮）
        this.isPlainDefault = ' ' // 将默认的按钮赋值为true（变成朴素按钮）
      }
    },
    async cancelChapter () { // 取消
      this.dialogVisible = false
    },
    bookUpSuccess (res, file) { // 文件上传
      this.chapterList = [...this.chapterList, ...res.data]
    },
    handleRemove (file, fileList) { // 文件删除
      this.chapterList.splice(file, 1)
    },
    async confirmChapter () { // 确认新增
      const isEdit = this.dialogType === 'edit'
      if (isEdit) { // 编辑章节
        this.requestData.data = this.chapter
        this.requestData.data.bookId = parseInt(this.$route.query.id)
        console.log('this.requestData.data.price', this.requestData.data.price)
        this.requestData.data.price = parseFloat(this.requestData.data.price === null ? 0 : this
          .requestData.data
          .price)
        this.requestData.data.reviewState = this.requestData.data.reviewState === true ? 1 : 0
        // await updateChapterInfo(this.requestData)
      } else { // 新增章节
        this.requestDatas = this.$generateChapters(this.chapterList, parseInt(this.$route.query.id), this
          .chapter.isCharge,
        this.chapter.price)
        // await addChapterList(this.requestDatas)
        this.requestData.data.bookId = parseInt(this.$route.query.id)
        // this.getChapterList(this.requestData)
        // this.setMaxChapterId()
      }

      this.$message({
        type: 'success',
        message: isEdit ? '编辑成功！' : '新增成功!'
      })
      this.fileList = []
      this.dialogVisible = false
    },
    toggleBack () {
      this.$router.back()
    },
    toggleList (type, index) {
      this.btnGroup(index)
      this.edit = false
      this.add = false
      this.contentTitle = type
      this.setStatus(type)

      this.refreshList()
    },
    // 1、草稿；2、回收；3、已发布
    setStatus (type) {
      this.reqDataList.data.status = 1
      this.reqDataList.data.page = 1
      if (type === '草稿箱') {
        this.reqDataList.data.status = 1
      } else if (type === '已发布') {
        this.reqDataList.data.status = 125
      } else if (type === '回收站') {
        this.reqDataList.data.status = 124
      }
    },
    closedialog () {
      this.refreshList()
      this.fileList = []
    },
    // 刷新数据
    refreshList () {
      // 刷新contentTitle类型的数据
      let that = this
      getAuthorChapterContentList(this.reqDataList).then(res => {
        if (res.code == 0) {
          that.tableData = res.data
          that.total = res.total
        } else {
          this.$message({
            message: res.msg,
            center: true
          })
        }
      })
    },
    handleCurrentChange (val) {
      this.reqDataList.data.page = val

      this.refreshList()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val

      this.$emit('fromParent', 111)
    },
    rowClick (row, type) {
      // console.log("rowClick() row, type", row, type);
      // row 行信息
      // type 草稿箱：0定时发布1发布2编辑3删除；已发布：4修改5删除；回收站：6还原7彻底删除 8 批量上传
      switch (type) {
        case 0:
          this.schedulePublish(row) // 定时发布
          break
        case 1:
          this.publish(row) // 发布
          break
        case 2:
          this.cedit(row) // 编辑
          break
        case 3:
          this.cdelete(row) // 删除
          break
        case 4:
          this.pedit(row) // 修改
          break
        case 5:
          this.pdelete(row) // 删除
          break
        case 6:
          this.restore(row) // 还原
          break
        case 7:
          this.rdelete(row) // 彻底删除
          break
      }
    },
    publishClick (type) { // 草稿箱：1批量发布2定时发布；已发布：3批量删除；回收站：4批量还原草稿5批量彻底删除
      switch (type) {
        case 1:
          this.batchPublish() // 草稿箱：1批量发布
          break
        case 2:
          this.batchSchedulePublish() // 草稿箱：2定时发布
          break
        case 3:
          this.batchDelte() // 已发布：3批量删除；
          break
        case 4:
          this.batchRestore() // 回收站：4批量还原草稿
          break
        case 5:
          this.batchDelteCompelete() // 回收站：5批量彻底删除
          break
        case 6:
          // console.log("上传文件",this.userInfo)
          this.batchupload() // 回收站：5批量彻底删除
          break
      }
    },
    searchChapter (e) {
      console.log('searchChapter', e)
      this.reqDataList.data.name = e.name
      this.refreshList()
    },
    btnClick (arg) { // 点击按钮事件
      console.log('btnClick', arg)
      if (arg < 5) {
        this.$refs['form'].validate((valid) => {
          // const idRule = /^Chapter *[0-9]\d*/g
          const idRule = /^Chapter * (^(0.*[1-9])|.*[1-9].*$)/g
          if (valid) {
            this.reqAddChapter.data[0].content = tinyMCE.activeEditor.getContent() // 获取富文本框的内容
            if (!this.reqAddChapter.data[0].name.match(idRule) && !this.editStatus) {
              this.$message({
                message: 'The title should include Chapter Number',
                center: true
              })
              this.nameInputErr = 'The format should be: Chapter Number Title'
              this.isSubmit = false
              return
            }
            if (this.words == 0) {
              this.$message({
                message: 'Fill in Chapter content',
                center: true
              })
              this.isSubmit = false
              return
            }
            switch (arg) {
              case 1: // 直接发布
                this.isSubmit = true
                this.$confirm(this.$t('writing.conftitle'), this.$t('writing.hint'), {
                  confirmButtonText: this.$t('writing.sure'),
                  cancelButtonText: this.$t('writing.close'),
                  type: 'warning'
                }).then(() => {
                  this.directPublish()
                }).catch(() => {
                  this.isSubmit = false
                  // this.$message({
                  //   type: 'info',
                  //   message: '已取消删除'
                  // } )
                })
                // this.directPublish()
                break
              case 2: // 定时发布
                this.schedulePublishNoRow()
                break
              case 3: // 预览查看
                this.preview()
                break
              case 4: // 存入草稿箱
                this.isSubmit = true
                if (this.reqAddChapter.data[0].name == '' && !this.editStatus) {
                  this.$message({
                    message: 'Chapter Number cannot be empty',
                    center: true
                  })
                  this.isSubmit = false
                  return
                }
                if (this.add) {
                  this.saveDrafts(1)
                } else { // 更新草稿
                  this.updateDrafts(1)
                }
                break
            }
          } else {
            return false
          }
        })
      } else {
        this.cancelSave() // 取消
      }
    },
    async publish (row) { // 草稿箱：1发布
      // 获取书籍信息
      this.reqPublishData.data.Books = await this.getBookList()
      this.reqPublishData.data.Chapters = this.getChapterList(row)
      // console.log("this.reqPublishData.data.Chapters1",this.reqPublishData.data.Chapters)
      await this.getLabelShips(this.bookId, 1)
      this.doPublsh(1)
    },
    getChapters () {
      let str = ''
      let num = 0
      if (this.reqPublishData.data.Chapters.length > 0) {
        this.reqPublishData.data.Chapters.forEach(a => str += `${a.bookNameEn}-${a.ChapterNameEn} `)
        this.reqPublishData.data.Chapters.forEach(a => num += a.words)

        str = this.reqPublishData.data.Chapters.length + '^' + num + '^' + str
      }
      return str
    },
    doPublsh (type) { // 1、草稿箱发布2、直接发布
      const str = this.getChapters()
      this.$eventRequest({
        mode: 'Publsh',
        title: str,
        etype: 'click'
      })
      // 这里点击发布后 然后点击 取消 会提交到草稿箱，导致草稿箱有当前章节，当前页面也有相同章节
      // this.$confirm(this.$t('writing.conftitle'), this.$t('writing.hint'), {
      // 	confirmButtonText: this.$t('writing.sure'),
      // 	cancelButtonText: this.$t('writing.close'),
      // 	type: 'warning'
      // }).then(() => {
      if (this.reqPublishData.data.Chapters.length > 0) {
        this.loading = true
        publish(this.reqPublishData).then(res => {
          this.loading = false
          this.$eventRequest({
            mode: 'Publsh',
            title: str,
            etype: 'succss'
          })
          if (res.code == 0) {
            const chapterIds = this.getChapterIds(res.data.chapters)
            this.doUpdate(chapterIds, 125, 'Publish Sucess', type) // 发布成功
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'danger',
          message: 'The chapter cannot be empty'
        })
      }
      // }).catch(() => {
      // 	// this.$message({
      // 	//   type: 'info',
      // 	//   message: '已取消删除'
      // 	// } )
      // })
      // 发布
    },
    afterPublish (type) { // 发布后
      switch (type) {
        case 1: // 草稿箱：1直接发布
          this.refreshList()
          break
        case 2: // 2直接发布
          this.toggleList('已发布', type)
          break
      }
    },
    // 考勤部分：记录发布章节的字数
    doPublishChapterReport (ids) {
      const reqData = {
        data: {
          bookId: this.bookInfo.id,
          ChapterIds: ids
        }
      }
      console.log('addPublishChapterReport req', reqData)
      addPublishChapterReport(reqData).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 发布之后更新作家系统的文章状态
    doUpdate (ids, status, msg, type) {
      const reqData = {
        data: {
          bookId: this.bookInfo.id,
          chapterIds: ids,
          status: status
        }
      }
      updateAuthorChapterListStatus(reqData).then(res => {
        if (res.code == 0) {
          this.afterPublish(type)
          this.doPublishChapterReport(ids)
          this.$message({
            type: 'success',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    getChapterIds (rows) {
      let ids = []
      for (let index in rows) {
        ids.push(rows[index].id)
      }
      return ids
    },
    getChapterListByRows (rows) { // 获取章节信息
      let chapters = []
      for (let index in rows) {
        let row = rows[index]
        const chapter = {
          id: row.id,
          IsCharge: 0,
          NovelBookId: 0,
          bookNameEn: row.bookName,
          ChapterId: row.chapterId,
          CurrentChapter: row.name,
          ChapterNameEn: row.name,
          ContextEn: row.content,
          Price: 0
        }
        chapters.push(chapter)
      }
      return chapters
    },
    getChapterList (row) { // 获取章节信息
      let chapters = []
      const chapter = {
        id: row.id,
        IsCharge: 0,
        NovelBookId: 0,
        bookNameEn: row.bookName,
        ChapterId: row.chapterId,
        CurrentChapter: row.name,
        ChapterNameEn: row.name,
        ContextEn: row.content,
        Price: 0,
        words: row.words,
        authorWords: row.authorWords
      }
      console.log('getChapterList', chapter)
      console.log('getChapterList row', row)
      chapters.push(chapter)
      return chapters
    },
    submitForm () {
      // console.log("刷新");
      this.dialogVisible = false
      this.refreshList()
    },
    async getBookList () { // 获取书籍信息
      let labelShips = await this.getLabelShips(this.bookId, 1)
      let books = []
      const book = {
        bookNo: this.bookInfo.bookNo,
        worksId: this.bookInfo.id,
        bookNameEn: this.bookInfo.worksName,
        introductionEn: this.bookInfo.introduction,
        coverPath: this.bookInfo.converPath,
        chapterCount: 0,
        novelBookId: 0,
        typeIds: [],
        labelShips: labelShips || [],
        authorId: this.userInfo.id,
        authorName: this.userInfo.pseudonym
      }
      // 以前是单个的 现在需要多个标签类型
      // book.typeIds.push(this.bookInfo.workTypeId)
      for (let i in this.worksTypeList) {
        book.typeIds.push(this.worksTypeList[i].workTypeId)
      }
      console.log('getBookList() book', book)
      books.push(book)
      return books
    },
    cedit (row) { // 草稿箱：2编辑
      console.log('cedit', row)
      this.editStatus = false
      this.nameInputErr = ''
      this.words = row.words
      if (row.status == 125) {
        this.chapterIsEdit = false
      } else {
        row.status = 1
      }
      row.content = this.handlerCotentLine(row.content)
      this.reqAddChapter.data = []
      this.reqAddChapter.data.push(row)

      this.edit = true
    },
    cdelete (row) { // 草稿箱：3删除
      this.multipleSelection = []
      this.multipleSelection.push(row)

      this.batchDelte()
      this.multipleSelection = []
    },
    pedit (row) { // 已发布：4修改
      this.cedit(row)
    },
    pdelete (row) { // 已发布：5删除
      this.cdelete(row)
    },
    restore (row) { // 回收站：6还原
      this.multipleSelection = []
      this.multipleSelection.push(row)

      this.batchRestore()
      this.multipleSelection = []
    },
    rdelete (row) { // 回收站：7彻底删除
      this.multipleSelection = []
      this.multipleSelection.push(row)

      this.batchDelteCompelete()
      this.multipleSelection = []
    },
    newAdd (index) { // 新增章节
      this.editStatus = true
      this.nameInputErr = ''
      this.btnGroup(index)
      this.reqAddChapter.data = []
      this.reqAddChapter.data.push({
        ...this.addChapterInfo
      })
      this.add = true
      this.chapterIsEdit = true
      this.getLastPublishChapterInfo()
    },
    async batchPublish () { // 批量发布
      // 获取书籍信息
      this.reqPublishData.data.Books = await this.getBookList()
      this.reqPublishData.data.Chapters = this.getChapterListByRows(this.multipleSelection)
      await this.getLabelShips(this.bookId, 1)

      // console.log("this.reqPublishData.data.Chapters2",this.reqPublishData.data.Chapters)
      this.doPublsh(1)
    },
    async getLabelShips (bookId, type) {
      const data = {
        data: {
          workId: parseInt(bookId),
          page: 1,
          limit: 100
        }
      }
      let res = await apiGetLabelContactBook(data)
      if (type === 1) {
        this.reqPublishData.data.LabelShips = res.data
      } else if (type === 2) {
        this.reqSecdulePublishData.data.LabelShips = res.data
      }
      this.reqPublishData.data.LabelShips = res.data
      return res.data
      //    console.log('获取的标签数据1', this.reqPublishData.data.LabelShips)
    },
    batchSchedulePublish () { // 草稿箱：2定时发布
      if (!this.checkSelection(this.multipleSelection, 'Please select the chapter you want to publish')) return

      this.dialogFormVisible = true
    },
    batchDelte () { // 已发布：3批量删除；
      this.updateRowStatus(this.multipleSelection, 124, 'Chapters that are not selected for deletion',
        'The deleted chapter will be found in Recycle,delete？', 'Delete Sucesss!', 'Delete canceled')
    },
    batchRestore () { // 回收站：4批量还原草稿
      this.updateRowStatus(this.multipleSelection, 1,
        'Chapters Not selected for Deletion Chapters not selected for restoring the draft',
        'Restore draft?', 'Restore Sucesss!', 'Recover canceled')
    },
    batchDelteCompelete () { // 回收站：5批量彻底删除
      this.updateRowStatus(this.multipleSelection, 127, 'Chapters that are not selected for deletion',
        'Undeleted chapters cannot be restored after they are completely deleted,delete？',
        'Complete deletion Succeeded!', 'Delete canceled')
    },
    batchupload () { // 草稿箱：6批量上传章节
      // this.updateRowStatus(this.multipleSelection, 127, '未选择删除的章节', '彻底删除后将会无法还原，确认删除?', '彻底删除成功!', '已取消删除')
      this.addChapter()
    },
    addChapter () { // 批量新增章节
      this.dialogType = 'new'
      this.dialogVisible = true
      this.chapter = {}
      this.chapterList = []
      this.chapter.chapterId = this.maxChapterId + 1
      console.log('this.chapterList', this.chapterList)
    },
    directPublish () { // 直接发布
      console.log('directPublish  this.add', this.add)
      if (this.add) {
        // 先保存草稿
        this.saveDrafts(2)
      } else { // 更新
        this.updateDrafts(2)
      }
    },
    schedulePublishNoRow () { // 新增章节，定时发布
      this.newChapterSechdule = true
      this.dialogFormVisible = true
    },
    schedulePublish (row) { // 定时发布
      this.multipleSelection = []
      this.multipleSelection.push(row)
      this.dialogFormVisible = true
    },
    comfrimSchedule (formName) { // 确认定时任务
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.newChapterSechdule) { // 新增章节定时发布
            if (this.add) {
              // 先保存草稿
              this.saveDrafts(3)
            } else { // 先更新草稿
              this.updateDrafts(3)
            }
          } else {
            // 定时发布
            this.doSchedule(this.multipleSelection)
          }
          this.newChapterSechdule = false
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    closeSechedule () {
      this.newChapterSechdule = false
      this.dialogFormVisible = false
    },
    async doSchedule (dataList) { // 定时发布
      // 获取书籍信息
      this.reqSecdulePublishData.data.Books = await this.getBookList()
      this.reqSecdulePublishData.data.Chapters = this.getChapterListByRows(dataList)
      this.reqSecdulePublishData.data.runtime = formatDateYYMMDDTHHmmss(this.scdModel.time)
      this.reqSecdulePublishData.data.timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.reqSecdulePublishData.data.timeoffset = new Date().getTimezoneOffset()
      await this.getLabelShips(this.bookId, 2)
      if (new Date(this.reqSecdulePublishData.data.runtime) <= new Date()) {
        this.$message({
          message: 'The scheduled time should be greater than the present time.',
          icon: 'error',
          center: true
        })
        return
      }
      this.loading = true

      const str = this.getChapters()
      this.$eventRequest({
        mode: 'Schedule',
        title: str,
        etype: 'click'
      })
      postArticle(this.reqSecdulePublishData).then(res => {
        this.$eventRequest({
          mode: 'Schedule',
          title: str,
          etype: 'success'
        })
        this.loading = false
        this.toggleList('Draft')
        if (res.code == 0) { // 更新狀態
          console.log('this.reqSecdulePublishData', this.reqSecdulePublishData)
          this.afterPostArticle(this.reqSecdulePublishData)
        } else {
          this.$message({
            message: res.msg,
            icon: 'error',
            center: true
          })
        }
      }).catch(e => {
        this.loading = false
        this.toggleList('Draft')
      })
    },
    afterPostArticle (data) { // 更新為定时发布
      let ids = []
      console.log('data', data)
      for (let item in data.data.Chapters) {
        console.log('item', item)
        console.log('data.Chapters[item]', data.data.Chapters[item])
        ids.push(data.data.Chapters[item].id)
      }

      var reqData = {
        data: {
          chapterIds: ids,
          status: 1,
          runTime: data.data.runtime
        }
      }
      // 更新章节内容集合定时任务状态
      updateAuthorChapterListSechdule(reqData).then(res => {
        if (res.code == 0) {
          this.refreshList()
          this.$message({
            message: 'Published successfully',
            icon: 'success',
            center: true
          })
        } else {
          this.$message({
            message: res.msg,
            icon: 'error',
            center: true
          })
        }
      })
    },
    preview () { // 预览查看
      this.viewChapter = this.reqAddChapter.data[0]

      this.viewShowDialog = true
    },
    saveDrafts (type) { // 1、存入草稿箱；2、直接发布（先存入草稿）；3、定时发布（先存入草稿）。
      console.log('begin saveDrafts')
      console.log('this.reqAddChapter', this.reqAddChapter)
      console.log('saveDrafts type', type)
      console.log('this.bookInfo', this.bookInfo)
      // let chapterName = this.reqAddChapter.data[0].name
      this.reqAddChapter.data[0].words = this.words
      this.reqAddChapter.data[0].bookId = this.bookInfo.id
      this.reqAddChapter.data[0].name = 'Chapter ' + this.autoInput + ' ' + this.reqAddChapter.data[0].name
      // this.reqAddChapter.data[0].name = "Chapter " + this.autoInput + " " + chapterName
      this.reqAddChapter.data[0].bookName = this.bookInfo.worksName
      this.reqAddChapter.data[0].userId = this.$store.state.userInfo.id
      this.reqAddChapter.data[0].id = 0
      addAuthorChapterContent(this.reqAddChapter).then(res => {
        // this.reqAddChapter.data[0].name = chapterName
        if (res.code == 0) {
          if (this.afterDrafts(type, res.data)) {
            this.$message({
              message: res.msg,
              icon: 'success',
              center: true
            })
          }
          this.isSubmit = false
          this.nameInputErr = ''
        } else {
          this.$message({
            message: res.msg,
            center: true
          })
          this.isSubmit = false
        }
      })
    },
    updateDrafts (type) { // 更新草稿
      console.log('updateDrafts11', this.reqAddChapter)
      // this.reqAddChapter是不完整的对象不能用这个方法
      // this.updateAuthorChapterContentList(this.reqAddChapter, '保存成功', type)
      this.reqAddOneChapter.data.id = this.reqAddChapter.data[0].id
      this.reqAddOneChapter.data.name = this.reqAddChapter.data[0].name
      this.reqAddOneChapter.data.content = this.reqAddChapter.data[0].content
      this.reqAddOneChapter.data.authorWords = this.reqAddChapter.data[0].authorWords

      this.updateSomeDataContentList(this.reqAddOneChapter, '保存成功', type)
    },
    async afterDrafts (type, data) { // 返回true提示添加草稿的成功
      console.log('afterDrafts(type, data)', type, data)
      switch (type) {
        case 1: // 保存草稿
          this.toggleList('草稿箱', type)
          return true
        case 2: // 直接发布
          // 获取书籍信息
          // console.log("新增add还是编辑",this.add)
          this.reqPublishData.data.Books = await this.getBookList()
          await this.getLabelShips(this.bookId, 1)
          if (this.add) {
            this.reqPublishData.data.Chapters = this.getChapterList(this.reqAddChapter.data[0])
            this.reqPublishData.data.Chapters[0].id = data[0].key
            this.reqPublishData.data.Chapters[0].ChapterId = data[0].value
          } else {
            this.reqPublishData.data.Chapters = this.getChapterList(data)
          }
          this.doPublsh(type)
          break
        case 3: // 新增章节定时发布
          // console.log("this.reqPublishData.data.Chapters4",this.reqPublishData.data.Chapters)
          this.reqAddChapter.data[0].id = data[0].key
          this.reqAddChapter.data[0].ChapterId = data[0].value
          // 定时发布
          // console.log("this.reqPublishData.data.Chapters4",this.reqPublishData.data.Chapters)
          this.doSchedule(this.reqAddChapter.data)
          break
      }
      return false
    },
    cancelSave () { // 取消
      this.edit = false
      this.add = false
    },
    contentChange (e) { // 内容变化
      try {
        // this.reqAddChapter.data[0].content=tinyMCE.activeEditor.getContent()
        // console.log("begin contentChange(e) e",e);
        // console.log("contentChange this.reqAddChapter.data[0].content",this.reqAddChapter.data[0].content);
        let changecontextEN = tinyMCE.activeEditor.getContent()
        console.log('changecontextEN', changecontextEN)
        // console.log("contentChange contextEN",changecontextEN);

        // 英文的总数
        var reg0 = new RegExp('\\W+', 'g')
        var reg1 = /[.,!?;:'"-]+/g
        var reg2 = /[，。！？；：“”‘’（）【】《》、……——]+/g
        // 匹配中文字符的正则表达式
        const chineseRegex = /[\u4e00-\u9fa5]/g
        console.log('changecontextEN.match(chineseRegex)..1.', changecontextEN.match(chineseRegex))
        console.log('changecontextEN.match(chineseRegex)..2.', changecontextEN.match(reg0))

        // var reg0 = new RegExp('\\b', 'gi')
        if (changecontextEN != null && changecontextEN != '') {
          changecontextEN = this.matchReg(changecontextEN)
          changecontextEN = this.handlerCotent(changecontextEN)
          console.log('contentChange contextEN', changecontextEN)

          this.words = (changecontextEN.match(chineseRegex) || []).length + (changecontextEN.match(reg2) ||
						[]).length
          if (changecontextEN.match(reg0) != null) {
            this.words += changecontextEN.match(reg0).length + (changecontextEN.match(reg1) || []).length
          } else {
            this.words = 1
          }
        } else {
          this.words = 0
        }
        /* var reg = new RegExp('\\b', 'gi')
					this.words = e.match(reg).length / 2 //单词个数 */
        // console.log("字数",this.words)
        if (this.reqAddChapter.data[0] != undefined) {
          this.reqAddChapter.data[0].words = this.words
        }
      } catch (e) {
        // TODO handle the exception
        this.words = 0
      }
    },
    // dataList更新的集合，status更新为状态（1、草稿；2、回收；3、已发布），noSeltMsg更新集合为空提示，comfirmMsg确认询问提示
    // successMsg成功更新提示，cancelMsg取消提示 sechduleTime：定时发布时间
    updateRowStatus (dataList, status, noSeltMsg, comfirmMsg, successMsg, cancelMsg) {
      this.updateRowStatus(ddataList, status, noSeltMsg, comfirmMsg, successMsg, cancelMsg, 0)
    },
    // dataList更新的集合，status更新为状态（1、草稿；2、回收；3、已发布），noSeltMsg更新集合为空提示，comfirmMsg确认询问提示
    // successMsg成功更新提示，cancelMsg取消提示 isScheduled:1定时发布0否 sechduleTime：定时发布时间
    updateRowStatus (dataList, status, noSeltMsg, comfirmMsg, successMsg, cancelMsg, isScheduled, sechduleTime) {
      if (!this.checkSelection(dataList, noSeltMsg)) return

      this.$confirm(comfirmMsg, '警告', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let that = this
        this.reqAddChapter.data = []
        this.reqAddChapter.data = dataList
        for (let item in this.reqAddChapter.data) {
          this.reqAddChapter.data[item].status = status
          if (isScheduled) {
            this.reqAddChapter.data[item].isScheduled = isScheduled
            this.reqAddChapter.data[item].scheduledTime = sechduleTime
          }
        }

        this.updateAuthorChapterContentList(this.reqAddChapter, successMsg).then(res => {
          if (res) {
            this.refreshList()
          }
        })
      }).catch((e) => {
        this.$message({
          type: 'info',
          message: cancelMsg
        })
      })
    },
    // 校驗已选的集合是否为空，false是
    checkSelection (dataList, noSeltMsg) {
      if (dataList.length == 0) {
        this.$message({
          type: 'info',
          message: noSeltMsg
        })
        return false
      }
      return true
    },
    // 更新状态，单个对象
    async updateAuthorChapterContentInfo (data, msg) {
      var res = await updateAuthorChapterContentInfo(data)
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: res.msg
        })
        return true
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
        return false
      }
    },
    // 更新状态，集合
    async updateAuthorChapterContentList (dataList, msg, type) {
      var res = await updateAuthorChapterContentList(dataList)
      if (res.code == 0) {
        if (this.afterDrafts(type, res.data)) {
          this.$message({
            type: 'success',
            message: res.msg
          })
        }
        return true
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
        return false
      }
    },
    // 更新状态，集合
    async updateSomeDataContentList (dataList, msg, type) {
      var res = await updateSomeDataContentList(dataList)
      if (res.code == 0) {
        if (this.afterDrafts(type, res.data)) {
          this.$message({
            type: 'success',
            message: res.msg
          })
        }
        this.isSubmit = false
        return true
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
        return false
      }
    },
    getBookIds () { // 获取书籍内码
      let ids = []
      this.reqPublishData.data.Chapters.forEach(a => {
        if (ids.indexOf(a.bookId) == -1) {
          ids.push(a.bookId)
        }
      })
      return ids
    },
    async getBookInfo () { // 获取作品信息
      const reqBookInfo = {
        data: {
          id: parseInt(this.bookId)
        }
      }
      var res = await getAuthorWorksInfo(reqBookInfo)
      if (res.code == 0) {
        this.bookInfo = res.data
      }
      console.log('this.bookInfo', this.bookInfo)
    },
    async getLastPublishChapterInfo () { // 获取作品信息
      const reqBookInfo = {
        data: parseInt(this.bookId)
      }
      var res = await getLastPublishChapter(reqBookInfo)
      if (res.code == 0) {
        this.publishChapter = res.data.name
        // 根据正则 拿到第几章
        // const idRule = /(?<=chapter *)[0-9]\d*/i
        const idRule = /[0-9]\d*/
        this.autoInput = parseInt(this.publishChapter.toLowerCase().match(idRule)) + 1
      }
      console.log('this.publishChapter', this.publishChapter)
      console.log('this.autoInput', this.autoInput)
    },
    // 根据ID查询书的类型
    getAuthorWorksTypeByWorkIdnew () {
      let data = {
        data: {
          workId: parseInt(this.bookId)
        }
      }
      getAuthorWorksTypeByWorkIdnew(data).then(res => {
        if (res.code == 0) {
          this.worksTypeList = res.data
        }
      })
    },
    matchReg (content) { // 去掉html标签
      var reg0 = new RegExp('<(\S*?)[^>]*>.*?|<.*? />', 'g')
      content = content.replace(reg0, '')
      return content
    },
    handlerCotent (content) {
      // console.log("handlerCotent",content);
      if (content == null) return content
      var reg0 = new RegExp('&ldquo;', 'g')
      content = content.replace(reg0, '\“')
      var reg1 = new RegExp('&rdquo;', 'g')
      content = content.replace(reg1, '\”')
      var reg2 = new RegExp('&lsquo;', 'g')
      content = content.replace(reg2, '\‘')
      var reg3 = new RegExp('&rsquo;', 'g')
      content = content.replace(reg3, '\’')
      var reg4 = new RegExp('&sbquo;', 'g')
      content = content.replace(reg4, '\‚')
      var reg5 = new RegExp('&hellip;', 'g')
      content = content.replace(reg5, '\…')
      var reg51 = new RegExp('&ndash;', 'g')
      content = content.replace(reg51, '\–')
      var reg6 = new RegExp(
        '<span class[=""]* data-index="[0-9]*" data-correctchunk="[a-zA-Z ]*" data-orgchunk="[a-zA-Z ]*" data-fixedstartpos="[0-9]*" data-fixedendpos="[0-9]*" data-errortype="errorLine">',
        'gi')
      content = content.replace(reg6, '')
      var reg7 = new RegExp('\<\/span>', 'g')
      content = content.replace(reg7, '')
      var reg8 = new RegExp('&nbsp;', 'g')
      content = content.replace(reg8, ' ')

      return content
    },
    handlerCotentLine (content) {
      if (content == null) return content
      var reg0 = new RegExp('\r', 'g')
      content = content.replace(reg0, '\n')
      var reg1 = new RegExp('\n\n', 'g')
      content = content.replace(reg1, '\n')
      var reg2 = new RegExp('\n\n', 'g')
      content = content.replace(reg2, '\n')
      var reg3 = new RegExp('\n', 'g')
      content = content.replace(reg3, '<br>')

      return content
    },
    async loadData () {
      if (this.$route.query.buttontype == 'add') {
        this.newAdd(null)
      }
      this.getBookInfo()
      this.getAuthorWorksTypeByWorkIdnew() // 获取书类型
      await this.getLastPublishChapterInfo()
      // 如果是点击的情况加载完数据跳新增章节
      console.log('按钮', this.$route.query.buttontype)
    }
  },
  created () {
    // this.uploadUrl = process.env.VUE_APP_BASE_API + `/Book/UploadFile?dir=BookFiles/${this.$route.query.bookName}`
    this.uploadUrl = process.env.VUE_APP_BASE_API +
				`/api/AuthorChapterContent/UploadChapters?userid=${this.$store.state.userInfo.id}&novelId=${this.$route.query.id}&novelName=${this.$route.query.worksName}`
    // console.log("created userid",this.$store.state.userInfo.id)
    this.bookId = this.$route.query.id
    this.reqDataList.data.bookId = this.$route.query.id
    let listType = this.$route.query.listtype
    this.hasPublished = this.$route.query.hasPublished
    console.log('发布状态', typeof this.hasPublished)
    // this.refreshList()
    this.toggleList(listType == 1 ? '草稿箱' : '已发布', listType == 1 ? 1 : 2)
    this.loadData()
  }

}
</script>

<style lang="scss" scoped="scoped">
	.containerPage {
		background-color: transparent;
		position: relative;
		overflow: initial;

		.top-btns {
			position: absolute;
			top: -45px;
			right: 0;
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
		}

		.title {
			height: 56px;
			background-color: #FFFFFF;
			padding: 0 20px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			.name {
				font-size: 18px;
				font-weight: bold;
				line-height: 50px;
			}
		}

		.typeList-content {
			// background-color: #FFFFFF;
			margin-bottom: 20px;
			border-radius: 6px;
			overflow: hidden;
		}

		.top-content {
			background-color: #FFFFFF;
			margin-bottom: 20px;
			border-radius: 6px;
			overflow: hidden;

			.center {
				padding: 10px 20px;
			}
		}

		.viewModul {
			width: 90%;
			height: 550px;
			min-height: 550px;
			margin: 0 auto;
			border: 5px solid #e9e6f1;
			border-radius: 16px;
			overflow-y: auto;
			word-wrap: break-word;

			.phone-content {
				padding: 0 10px;

				.html {
					font-size: 14px;
					color: #333;

					.content {
						white-space: pre-wrap;
						word-break: keep-all;
						font-size: 14px;
						line-height: 21px;
						font-family: Arial;
					}
				}

				.html>div {
					margin: 10px 0;
				}
			}
		}

		.footer-content {
			background-color: #FFFFFF;
			margin-bottom: 20px;
			border-radius: 6px;
			overflow: hidden;

			.center {
				padding: 10px 20px;

				.row {
					display: flex;
					flex-direction: row;
					align-items: center;
					margin-bottom: 20px;

					span {
						margin-right: 30px;
					}
				}
			}
		}

		.info-updata-words {
			float: right;
		}
	}
</style>
